import type { PortfolioEvaluationPlan } from "Infrastructure/ApiZfp/Schema/portfolioEvaluationPlan";
import { PortfolioEvaluationWarningItemQuestionnaireEvaluationType } from "Infrastructure/ApiZfp/Schema/portfolioEvaluationWarningItemQuestionnaireEvaluationType";

// shown for a missing value, in the cards and the panel alike
export const EMPTY_VALUE = "–";

export const getRiskToleranceWarningItem = (evaluationPlan: PortfolioEvaluationPlan) =>
  (evaluationPlan.evaluationWarning?.instrumentWarningItems ?? []).find(
    (item) => item.questionnaireEvaluationType === PortfolioEvaluationWarningItemQuestionnaireEvaluationType.RiskToleranceType,
  );

export const formatSrriSri = (srri: number | null, sri: number | null): string => {
  if (!sri && !srri) return EMPTY_VALUE;

  const sriLabel = sri == null || sri === 0 ? EMPTY_VALUE : String(sri);
  const srriLabel = srri == null || srri === 0 ? EMPTY_VALUE : String(srri);
  return `${srriLabel} / ${sriLabel}`;
};

// Czech decimals, "1,5", with no trailing zeros: "7" for "7.00"
const formatDecimal = (value: number) => value.toLocaleString("cs-CZ", { maximumFractionDigits: 2 });

export const formatPercent = (value: number | null | undefined): string => (value == null ? EMPTY_VALUE : `${formatDecimal(value)} %`);

// a risk level comes as a string, e.g. "7.00"
export const formatRiskValue = (value: string | null | undefined): string => {
  const number = Number.parseFloat(value ?? "");
  return Number.isFinite(number) ? formatDecimal(number) : (value ?? EMPTY_VALUE);
};
